<template>
  <v-container> <component :is="component"></component> </v-container>
</template>
<script>
import SlcImprint from "@/components/SlcTosDialog/SlcImprint.vue";

export default {
  components: {
    SlcImprint
  },
  props: {
    component: {
      required: true
    }
  }
};
</script>
